// barcodeEvents.ts
type Callback = (barcode: string) => void;

const listeners = new Set<Callback>();

export function onBarcodeScan(cb: Callback) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function emitBarcode(barcode: string) {
  listeners.forEach((cb) => cb(barcode));
}
